export const SIMPLE = import.meta.env.VITE_SIMPLE === 'true' || import.meta.env.VITE_SIMPLE === '1';
export const THEME = (import.meta.env.VITE_THEME as string) || 'dark';
export const PROJECT_NAME = (import.meta.env.VITE_PROJECT_NAME as string) || 'LawBot.Pro';
